import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getLocalParticipant,  ParticipantView } from "../../base/participants";

function RemoteFilm({
    visibleRemoteParticipants, local, 
    style
}) {
 
    return (
        <>  
            { visibleRemoteParticipants.map(participantId => {
                const isLocal = local && participantId === local.user_uuid;
                return (
                    <div
                        key={participantId} 
                        className={`item item_${isLocal}`}
                        id={participantId}
                        style={style}
                        > 
                        <ParticipantView 
                            participantId={participantId}
                        />
                    </div>    
                );
            }) }
        </>
    )
}

function _mapStateToProps(state) {
    const { visibleRemoteParticipants } = state['features/video-layout-mode'];
    const local = getLocalParticipant(state);
    
    return {
        visibleRemoteParticipants: [...visibleRemoteParticipants],
        local
    }
}

export default connect(_mapStateToProps)(RemoteFilm);